import {getIconStringWithOrigin} from "@/utils/filters";
import moment from "moment"

export default function (cytoscape, settings) {
    //cytoscape.use(Layers);

    const nodeHtmlLabel = require('cytoscape-node-html-label');
    nodeHtmlLabel(cytoscape); // register extension
    cytoscape.use(require('cytoscape-dom-node'));

    let cy
    let graphSettings = settings

    const eleCache = new Map()
    const RemoveItemFromCacheById = (itemId) => {
        eleCache.delete(itemId)
        cy.$id(itemId).addClass("dummy")
        cy.$id(itemId).removeClass("dummy")
    }

    const RefreshNodes = () => {
        for (const node of cy.nodes())
        {
            eleCache.clear()
            RemoveItemFromCacheById(node.id())
        }
    }

    const createCategoryIcon = (categoryObject) => `
            <div class="category-container border" style="background-color: ${categoryObject.color};">
              <i class="v-icon notranslate material-icons theme--light ${getIconStringWithOrigin(categoryObject.icon)}" style="color: ${categoryObject.secondaryColor}; font-size: 20px"/>
              </i>     
            </div>
        `
    const TryCreateAddressIdentityLabel = (addressData) => {
        if (addressData.label) {
            return addressData.label
        }

        if (addressData.identities?.length > 0)
            if (addressData.identities[0].label)
                return addressData.identities[0].label

        return undefined;
    }

    const TryCreateAddressOwnerLabel = (addressData) => {
        if (addressData.owner)
            return addressData.owner.name

        if (addressData.owners?.length > 0)
            if (addressData.owners[0].name)
                return addressData.owners[0].name

        return undefined;
    }

    const CreateAddressLabel = (addressData) => {
        let addressString = TryCreateAddressIdentityLabel(addressData)
        if (addressString) {
            return `
            <div class="text-center fontMonospace d-flex align-center justify-center" style="gap: 4px; white-space: nowrap">
                <i class="fas fa-address-card" style="font-size: 16px; color: grey; bottom: 3px;"></i>                
                ${addressString}
            </div>
            `
        }

        addressString = TryCreateAddressOwnerLabel(addressData)
        if (addressString) {
            return `
            <div class="text-center fontMonospace d-flex align-center justify-center" style="gap: 4px; white-space: nowrap">
                <img data-v-c91c8658="" alt="Owner" src="/img/ico/owner-icon.svg" class="imgIcon" style="width: 16px;">
                ${addressString}
            </div>
        `
        }

        // Fallback to address hash
        const address = addressData.addr ?? addressData.address
        addressString = `${address.substring(0, 6)}…${address.slice(-4)}`

        return `
        <div class="text-center fontMonospace" style="white-space: nowrap; display: inline-block">
            ${addressString}
        </div>
        `
    }

    const createNodeAnnotation = (annotation) => {
        if (!annotation)
            return ""
        return `
        <div style="white-space: pre-line;" class="noteContent mb-2">${annotation}</div>
        `
    }

    const createMergeNodeLayer = (nodeId, data) => {
        const base = `
            <div style="pointer-events: none;" class="d-flex justify-center">
                ${createNodeAnnotation(data.annotation)}
                <div style="position: absolute; bottom: -82px; white-space: nowrap">
                    <div class="fontMonospace mt-n2">${data.customLabel ?? 'Custom node'}</div>
                </div>
            </div>
        `
        eleCache.set(nodeId, base)
        return base
    }

    const createAddressLayer = (nodeId, addressData, data) => {
        const base = `
            <div style="pointer-events: none;" class="d-flex justify-center">
                ${createNodeAnnotation(data.annotation)}
                <div style="position: absolute; bottom: -82px">
                    <div class="d-flex justify-center width100 align-center mt-2">
                        <div style="width: 28px; height: 28px">
                            ${addressData.categories[0] ? createCategoryIcon(addressData.categories[0]) : ''}
                        </div>
                        <div style="width: 24px">
                        </div>
                        <div style="width: 28px; height: 28px">
                        </div>
                    </div>
                    ${CreateAddressLabel(addressData)}
                </div>
            </div>
        `
        eleCache.set(nodeId, base)
        return base
    }
    const createTransactionTimestamps = (data) => {
        if(!graphSettings.value.showTxTimeStamp)
        {
            return ""
        }
        return `
            <div class="text-center" style="font-size: 14px;">
                ${moment.unix(data.typeSpecific.blockTime).format("YYYY-MM-DD")}
            </div>
            <div class="text-center mt-n1" style="font-size: 14px;">
                ${moment.unix(data.typeSpecific.blockTime).format("HH:mm:ss")}
            </div>
        `
    }

    //     ${data.inputsExpanded ? '' : '<i class="v-icon mdi mdi-plus-circle theme--light success--text" style="font-size: 12px"></i>'}
    //     ${data.outputsExpanded ? '' : '<i class="v-icon mdi mdi-plus-circle theme--light success--text" style="font-size: 12px"></i>'}
    const createTransactionLayer = (nodeId, data) => {
        const txHash = data.id
        const truncatedTxHash = `${txHash.substring(0, 4)}…${txHash.slice(-3)}`
        const base = `
            <div style="pointer-events: none;" class="d-flex justify-center">
                ${createNodeAnnotation(data.annotation)}
                <div style="position: absolute; bottom: ${graphSettings.value.showTxTimeStamp ? '-121px' : '-82px'}">
                    <div class="d-flex justify-center width100 align-top fontMonospace" style="font-size: 14px; margin-top: 8px; margin-bottom: 4px">
                        <div style="width: 42px; height: 14px" class="d-flex align-center justify-end">
                            ${data.typeSpecific.inputs.length}
                        </div>
                        <div class="d-flex align-center justify-center" style="height: 14px">
                        :
                        </div>
                        <div style="width: 42px; height: 14px" class="d-flex align-center justify-start">
                            ${data.typeSpecific.outputs.length}
                        </div>
                    </div>
                    <div>
                        ${createTransactionTimestamps(data)}
                        <div class="text-center fontMonospace mt-n1" style="font-size: 14px;">
                            ${truncatedTxHash}
                        </div>
                    </div>
                </div>
            </div>
        `
        eleCache.set(nodeId, base)
        return base
    }


    const Activate = (cyInstance) => {
        cy = cyInstance
        cy.domNode()
        cy.nodeHtmlLabel([
                {
                    query: '.address', // cytoscape query selector
                    halign: 'center', // title vertical position. Can be 'left',''center, 'right'
                    valign: 'top', // title vertical position. Can be 'top',''center, 'bottom'
                    halignBox: 'center', // title vertical position. Can be 'left',''center, 'right'
                    valignBox: 'top', // title relative box vertical position. Can be 'top',''center, 'bottom'
                    cssClass: '', // any classes will be as attribute of <div> container for every title
                    tpl: function (data) {
                        const eleData = eleCache.get(data.id)
                        if (eleData) {
                            return eleData
                        }
                        return createAddressLayer(data.id, data.typeSpecific.addressData, data)
                    }
                },
                {
                    query: '.transaction', // cytoscape query selector
                    halign: 'center', // title vertical position. Can be 'left',''center, 'right'
                    valign: 'top', // title vertical position. Can be 'top',''center, 'bottom'
                    halignBox: 'center', // title vertical position. Can be 'left',''center, 'right'
                    valignBox: 'top', // title relative box vertical position. Can be 'top',''center, 'bottom'
                    cssClass: '', // any classes will be as attribute of <div> container for every title
                    tpl: function (data) {
                        const eleData = eleCache.get(data.id)
                        if (eleData) {
                            return eleData
                        }
                        return createTransactionLayer(data.id, data)
                    }
                },
                {
                    query: '.merge', // cytoscape query selector
                    halign: 'center', // title vertical position. Can be 'left',''center, 'right'
                    valign: 'top', // title vertical position. Can be 'top',''center, 'bottom'
                    halignBox: 'center', // title vertical position. Can be 'left',''center, 'right'
                    valignBox: 'top', // title relative box vertical position. Can be 'top',''center, 'bottom'
                    cssClass: '', // any classes will be as attribute of <div> container for every title
                    tpl: function (data) {
                        const eleData = eleCache.get(data.id)
                        if (eleData) {
                            return eleData
                        }
                        return createMergeNodeLayer(data.id, data)
                    }
                },
                {
                    // query: '.note', // cytoscape query selector
                    // halign: 'center', // title vertical position. Can be 'left',''center, 'right'
                    // valign: 'top', // title vertical position. Can be 'top',''center, 'bottom'
                    // halignBox: 'center', // title vertical position. Can be 'left',''center, 'right'
                    // valignBox: 'center', // title relative box vertical position. Can be 'top',''center, 'bottom'
                    // cssClass: '', // any classes will be as attribute of <div> container for every title
                    // // tpl: function (data) {
                    // //     return `<div class="fontMonospace mt-n6 d-flex justify-center"><div class="noteContent" style="position: absolute;white-space: pre-wrap;bottom:6px;"
                    // //         onclick="((e) => {
                    // //               console.log('onClick',e)
                    // //               // e.stopPropagation();
                    // //               // e.preventDefault();
                    // //         })()"
                    // //         onmousedown="(() => {
                    // //               // e.stopPropagation();
                    // //               // e.preventDefault();
                    // //             const event = new CustomEvent('onMouseDownOnNote',{ detail: '${data.id}', bubbles: true });
                    // //             dispatchEvent(event)
                    // //         })()"
                    // //         onmouseup="(() => {
                    // //               // e.stopPropagation();
                    // //               // e.preventDefault();
                    // //             const event = new CustomEvent('onMouseUpOnNote',{ detail: '${data.id}', bubbles: true });
                    // //             dispatchEvent(event)
                    // //         })()">${data.text}</div></div>`
                    // // }
                    // tpl: function (data) {
                    //     return `<div class="fontMonospace mt-n6 d-flex justify-center"><div class="noteContent" style="position: absolute;white-space: pre-wrap;bottom:6px;" id="${data.id}">${data.text}</div></div>`
                    // }
                }
            ],
            {
                enablePointerEvents: true
            }
        );
    }


    // tpl: function (data) {
    //     return `<div class="fontMonospace mt-n6 d-flex justify-center"><div class="noteContent" style="position: absolute;white-space: pre-wrap;bottom:6px;"
    //                     onclick="((e) => {
    //                           console.log(e)
    //                           e.stopPropagation();
    //                           e.preventDefault();
    //                     })()"
    //                     onmousedown="(() => {
    //                           // e.stopPropagation();
    //                           // e.preventDefault();
    //                         const event = new CustomEvent('onMouseDownOnNote',{ detail: '${data.id}', bubbles: true });
    //                         dispatchEvent(event)
    //                     })()"
    //                     onmouseup="(() => {
    //                           // e.stopPropagation();
    //                           // e.preventDefault();
    //                         const event = new CustomEvent('onMouseUpOnNote',{ detail: '${data.id}', bubbles: true });
    //                         dispatchEvent(event)
    //                     })()">${data.text}</div></div>`
    // }

    return {Activate, RemoveItemFromCacheById, RefreshNodes}
}